import React from 'react'
import './Industries.css'
import i1 from '../Images/i1.svg';
import i2 from '../Images/i2.svg';
import i3 from '../Images/i3.svg';
import i4 from '../Images/i4.svg';
import i5 from '../Images/i5.svg';
import img from '../Images/industries.png';

// const data = [
//     {
//         id: 1,
//         icon: i1,
//         heading: "Retail & E-Commerce",
//         para: "Engaging product pages and smooth checkout experiences."
//     },
//     {
//         id: 2,
//         icon: i2,
//         heading: "FinTech & Banking",
//         para: "Secure, intuitive dashboards for finance management."
//     },
//     {
//         id: 3,
//         icon: i3,
//         heading: "Healthcare",
//         para: "Simplified interfaces for patient and doctor interactions."
//     },
//     {
//         id: 4,
//         icon: i4,
//         heading: "Real Estate",
//         para: "Easy property browsing and seamless inquiry journeys."
//     },
//     {
//         id: 5,
//         icon: i5,
//         heading: "SaaS & IT",
//         para: "Clean, user-friendly software dashboards and tools."
//     }
// ]

const servicesData = [
    {
        title: "What services do you offer?",
        description:
            "End-to-end UI/UX design including research, product & visual design, prototypes, UI development, and usability testing.",
    },
    {
        title: "How do you approach product design?",
        description:
            "User-centric, data-driven process from research to wireframes, prototypes, testing, and refinement.",
    },
    {
        title: "Which industries do you serve?",
        description:
            "FinTech, healthcare, eCommerce, gaming, education, and enterprise SaaS with tailored solutions.",
    },
    {
        title: "How long does a project take?",
        description:
            "Typically 4–12 weeks, depending on complexity, covering research, design, testing, and handoff.",
    },
    {
        title: "Do you provide post-delivery support?",
        description:
            "Yes, with developer-ready assets, documentation, and ongoing design support.",
    },
];

function Industries() {
    return (
        <div id='uiindustries'>
            <div className="section">
                <div className="container">
                    <div className="serviceleft">
                        {/* <h3 className="blueheading">
                            Industries We Serve
                        </h3> */}
                        <h1 className="heading">
                            Let’s Build Exceptional Experiences Together
                        </h1>
                        <p className="newpara">
                           Ready to elevate your digital presence with the best UI UX design services? Our expert team at BastionEx is here to transform your ideas into intuitive, engaging, and high-performing products.
                        </p>
                        <div className="imagebox">
                            <img src={img} alt="" />
                        </div>
                    </div>
                    <div className="serviceright services-container">
                        <h2 className='faq'>FAQs</h2>
                       <div className="service-list">
                         {servicesData.map((service, index) => (
                            <div key={index} className="service-card">
                                <div className="line"></div>
                                <div className="content">
                                    <h3 className='servicetitle'>{service.title}</h3>
                                    <p className='servicedescription'>{service.description}</p>
                                </div>
                            </div>
                        ))}
                       </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Industries